import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check, Minus } from "lucide-react"
import { cn } from "@/lib/utils"

const Checkbox = React.forwardRef<
	React.ComponentRef<typeof CheckboxPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
	<CheckboxPrimitive.Root
		ref={ref}
		className={cn(
			"peer h-4 w-4 shrink-0 rounded-sm border border-border/60 shadow-sm transition-colors",
			"focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
			"disabled:cursor-not-allowed disabled:opacity-50",
			"data-[state=checked]:bg-[#2d5c3f] data-[state=checked]:border-[#2d5c3f] data-[state=checked]:text-white",
			"data-[state=indeterminate]:bg-[#2d5c3f] data-[state=indeterminate]:border-[#2d5c3f] data-[state=indeterminate]:text-white",
			className,
		)}
		{...props}
	>
		<CheckboxPrimitive.Indicator className="flex items-center justify-center">
			{props.checked === "indeterminate" ? (
				<Minus className="h-3 w-3" />
			) : (
				<Check className="h-3 w-3" />
			)}
		</CheckboxPrimitive.Indicator>
	</CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
